import React from 'react';
import { findDOMNode } from 'react-dom';
import { TimelineLite } from 'gsap';
import globals from "../../globals";
import ScrollMagic from "../../plugins/ScrollMagic";

export default {

    initialise(InlineTextBlocks) {
        this.Node = findDOMNode(InlineTextBlocks);
        this.headings = [...this.Node.querySelectorAll('.column h3')];
        this.paragraphs = [...this.Node.querySelectorAll('.column p')];

        let controller = new ScrollMagic.Controller(),
            tl = new TimelineLite();

        if (this.headings.length > 0 && this.paragraphs.length > 0) {
            tl
                .staggerFromTo(this.headings, 0.5, {y: -75, opacity: 0}, {y: 0, opacity: 1}, 0.1, 0)
                .staggerFromTo(this.paragraphs, 0.5, {y: 75, opacity: 0}, {y: 0, opacity: 1}, 0.1, 0);
        }

        new ScrollMagic.Scene({
            triggerElement: '.inline-text-blocks',
            reverse: false
        })
            .setTween(tl)
            .addTo(controller);
    }

}


// WEBPACK FOOTER //
// ./resources/assets/js/modules/InlineTextBlocks/animations.js